import { Provider } from 'react-redux';
import store from 'state/store';
import AppRoutes from 'routes';
import config from 'config';
import initializeI18n from 'translations/translator';
import { useEffect } from 'react';

const LwtApp = () => {
  initializeI18n();

    useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (!event.origin.includes('lwtears.com') && !event.origin.includes('localhost')) return;
      if (event.data && event.data.type === 'applyStyle') {
        let style = document.getElementById(event.data.id);
        if (!style) {
          style = document.createElement('style');
          style.id = event.data.id;
          style.textContent = event.data.css;
          document.head.appendChild(style);
        }
      }

      if (event.data && event.data.type === 'removeStyle') {
        const style = document.getElementById(event.data.id);
        if (style) style.remove();
      }
    };

    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);
  
  return (
    <Provider store={store}>
      <AppRoutes useSSO={config.SSO_ENABLED} />
    </Provider>
  );
};
export default LwtApp;
